module.exports = __webpack_public_path__ + "img/undraw_online_posts.8ce05d68.svg";